import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchChfarOfferSaga } from "./fetchChfarOfferSaga";

export function* watchGetChfarOffer() {
  yield takeLatest(actionTypes.FETCH_CHFAR_OFFER, fetchChfarOfferSaga);
}
